import React, { useState } from "react";

const ListingForm = () => {
  const [userType, setUserType] = useState("");
  const [step, setStep] = useState(1);
  const [selectedProjectType, setSelectedProjectType] = useState("");
  const [selectedPropertyType, setSelectedPropertyType] = useState("");

  const handleNext = (e) => {
    e.preventDefault();
    if (step === 1) {
      setStep(2);
    }
  };

  const handleBack = (e) => {
    e.preventDefault();
    setStep(1);
  };

  return (
    <div className="p-6 flex justify-center">
      <div className="relative bg-white shadow-md rounded-lg w-full max-w-lg p-6 border-l-4 hover:shadow-xl hover:border-blue-600 transition duration-300 ease-in-out">
        <div
          className="absolute top-0 left-0 w-full h-2 rounded-t-lg"
          style={{ backgroundColor: "#36A2EB" }}
        ></div>

        <h2 className="text-lg font-bold text-gray-800 mb-6 flex items-center">
          {step === 1 ? "Step 1: Basic Details" : "Step 2: User Details"}
        </h2>

        <form>
          {step === 1 && (
            <>
              {/* It's a... */}
              <div className="mb-6">
                <label className="block text-gray-600 text-sm font-semibold mb-2">
                  It's a...
                </label>
                <div className="flex gap-4">
                  {["New Project", "Resale", "Rent"].map((option) => (
                    <div
                      key={option}
                      className={`border rounded-lg px-4 py-2 cursor-pointer flex items-center gap-2 hover:shadow-lg transition focus-within:ring-2 focus-within:ring-blue-500 ${
                        selectedProjectType === option
                          ? "bg-primaryOrange text-white"
                          : "text-gray-700"
                      }`}
                      onClick={() => setSelectedProjectType(option)}
                    >
                      <input
                        type="radio"
                        name="projectType"
                        value={option}
                        className="hidden"
                        id={option}
                      />
                      <label
                        htmlFor={option}
                        className="cursor-pointer w-full text-center"
                      >
                        {option}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              {/* Property Type */}
              <div className="mb-6">
                <label className="block text-gray-600 text-sm font-semibold mb-2">
                  Property Type...
                </label>
                <div className="flex gap-4">
                  {["Residential", "Commercial"].map((option) => (
                    <div
                      key={option}
                      className={`border rounded-lg px-4 py-2 cursor-pointer flex items-center gap-2 hover:shadow-lg transition focus-within:ring-2 focus-within:ring-blue-500 ${
                        selectedPropertyType === option
                          ? "bg-primaryOrange text-white"
                          : "text-gray-700"
                      }`}
                      onClick={() => setSelectedPropertyType(option)}
                    >
                      <input
                        type="radio"
                        name="propertyType"
                        value={option}
                        className="hidden"
                        id={option}
                      />
                      <label
                        htmlFor={option}
                        className="cursor-pointer w-full text-center"
                      >
                        {option}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              {/* You are... */}
              <div className="mb-6">
                <label className="block text-gray-600 text-sm font-semibold mb-2">
                  You are...
                </label>
                <div className="flex gap-4">
                  {["Broker", "Builder", "Owner"].map((option) => (
                    <div
                      key={option}
                      className={`border rounded-lg px-4 py-2 cursor-pointer flex items-center gap-2 hover:shadow-lg transition focus-within:ring-2 focus-within:ring-blue-500 ${
                        userType === option
                          ? "bg-primaryOrange text-white"
                          : "text-gray-700"
                      }`}
                      onClick={() => setUserType(option)}
                    >
                      <input
                        type="radio"
                        name="userType"
                        value={option}
                        className="hidden"
                        id={option}
                      />
                      <label
                        htmlFor={option}
                        className="cursor-pointer w-full text-center"
                      >
                        {option}
                      </label>
                    </div>
                  ))}
                </div>
                {/* {userType && (
                  <p className="mt-2 text-sm text-gray-600">
                    You selected: <span className="font-semibold">{userType}</span>
                  </p>
                )} */}
              </div>

              {/* Next Button */}
              <div className="mt-4">
                <button
                  type="button"
                  className="w-full bg-primaryOrange text-white py-2 px-4 rounded-lg font-semibold hover:bg-orange-600 transition"
                  onClick={handleNext}
                >
                  Next
                </button>
              </div>
            </>
          )}

          {step === 2 && (
            <>
              {userType === "Broker" && (
                <>
                  <div className="mb-4">
                    <label
                      htmlFor="fullName"
                      className="block text-gray-600 text-sm font-semibold mb-2"
                    >
                      Full Name
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      placeholder="Your Name"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="email"
                      className="block text-gray-600 text-sm font-semibold mb-2"
                    >
                      Email ID
                    </label>
                    <input
                      type="email"
                      id="email"
                      placeholder="you@example.com"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="phone"
                      className="block text-gray-600 text-sm font-semibold mb-2"
                    >
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      placeholder="123-456-7890"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="companyName"
                      className="block text-gray-600 text-sm font-semibold mb-2"
                    >
                      Company Name
                    </label>
                    <input
                      type="text"
                      id="companyName"
                      placeholder="Your Company"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="companyAddress"
                      className="block text-gray-600 text-sm font-semibold mb-2"
                    >
                      Company Address
                    </label>
                    <textarea
                      id="companyAddress"
                      placeholder="1234 Main St, City, State"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    ></textarea>
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="reraState"
                      className="block text-gray-600 text-sm font-semibold mb-2"
                    >
                      Select RERA State
                    </label>
                    <select
                      id="reraState"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    >
                      <option value="">Select State</option>
                      <option value="State1">State 1</option>
                      <option value="State2">State 2</option>
                    </select>
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="companyLogo"
                      className="block text-gray-600 text-sm font-semibold mb-2"
                    >
                      Upload Company Logo
                    </label>
                    <input
                      type="file"
                      id="companyLogo"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="reraNumber"
                      className="block text-gray-600 text-sm font-semibold mb-2"
                    >
                      RERA Registration Number
                    </label>
                    <input
                      type="text"
                      id="reraNumber"
                      placeholder="RERA Number"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                </>
              )}
              {userType === "Builder" && (
                <>
                <div className="mb-4">
                  <label
                    htmlFor="fullName"
                    className="block text-gray-600 text-sm font-semibold mb-2"
                  >
                    Full Name
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    placeholder="Your Name"
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="email"
                    className="block text-gray-600 text-sm font-semibold mb-2"
                  >
                    Email ID
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="you@example.com"
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="phone"
                    className="block text-gray-600 text-sm font-semibold mb-2"
                  >
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    placeholder="123-456-7890"
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="companyName"
                    className="block text-gray-600 text-sm font-semibold mb-2"
                  >
                    Company Name
                  </label>
                  <input
                    type="text"
                    id="companyName"
                    placeholder="Your Company"
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="companyAddress"
                    className="block text-gray-600 text-sm font-semibold mb-2"
                  >
                    Company Address
                  </label>
                  <textarea
                    id="companyAddress"
                    placeholder="1234 Main St, City, State"
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  ></textarea>
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="companyLogo"
                    className="block text-gray-600 text-sm font-semibold mb-2"
                  >
                    Upload Company Logo
                  </label>
                  <input
                    type="file"
                    id="companyLogo"
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />
                </div>
              </>
              )}
              {userType === "Owner" && (
                <>
                  <div className="mb-4">
                    <label
                      htmlFor="fullName"
                      className="block text-gray-600 text-sm font-semibold mb-2"
                    >
                      Full Name
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      placeholder="Your Name"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="email"
                      className="block text-gray-600 text-sm font-semibold mb-2"
                    >
                      Email ID
                    </label>
                    <input
                      type="email"
                      id="email"
                      placeholder="you@example.com"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="phone"
                      className="block text-gray-600 text-sm font-semibold mb-2"
                    >
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      placeholder="123-456-7890"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                </>
              )}
              {/* Common Buttons */}
              <div className="flex justify-between mt-4">
                <button
                  type="button"
                  className="bg-gray-100 text-gray-700 py-2 px-4 rounded-lg font-semibold hover:bg-gray-800 hover:text-white transition"
                  onClick={handleBack}
                >
                  Back
                </button>
                <button
                  type="submit"
                  className="bg-primaryOrange text-white py-2 px-4 rounded-lg font-semibold hover:bg-orange-600 transition"
                >
                  Add Listing
                </button>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default ListingForm;
